const rolesNames: { [key: string]: string } = {
  ciso: "ciso",
  property_admin: "admin",
  security_guard: "guard",
  host: "host",
  secondary_user: "secondary_host",
};

export const CISO_IDS = [7, 8];
export const PROPERTY_ADMIN_IDS = [11, 12];
export const SECURITY_GUARD_IDS = [15, 16];
export const HOST_IDS = [9, 10];
export const SECONDARY_USER_IDS = [13, 14];
export const VISITOR_IDS = [17, 18];

export const isVisitorRole = (
  role: { id?: number; name?: string; type?: string } | null | undefined,
) => {
  const roleName = role?.name?.toLowerCase() ?? "";
  const roleType = role?.type?.toLowerCase() ?? "";

  return (
    (!!role?.id && VISITOR_IDS.includes(role.id)) ||
    roleName.startsWith("visitor") ||
    roleType.startsWith("visitor")
  );
};

export default rolesNames;
